export enum formMode {
    Create = 'create',
    Edit = 'edit',
    View = 'view',
    info = 'information',
    duplicate = 'duplicate'
}

export enum customFields {
    Text = 1,
    MultilineText = 2,
    Number = 3,
    Date = 4,
    List = 5,
    SingleCheckBox = 6,
    Link = 8,
    RadioButton = 9 
}